<template>
    <md-sidenav class="md-left" ref="layerNav">
        <md-toolbar class="md-dense main-toolbar">
            <md-button class="md-icon-button" @click="back()">
                <md-icon>menu</md-icon>
            </md-button>
            <h3 class="md-title">Layers</h3>
        </md-toolbar>
        <layer-list :project="project" :layers="layers" @showLayer="showLayer" @hideLayer="hideLayer" />
        <layer-picker :layers="validLayers" :currentLayer="currentLayer" v-if="validLayers.length > 0"></layer-picker>
        <layer-new v-if="canEdit" :project="project" @showLayer="showLayer" @addLayer="addLayer"/>
    </md-sidenav>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import LayersLayerList from '@/components/layers/layer-list';
import LayersLayerNew from '@/components/layers/layer-new';
import LayersLayerPicker from '@/components/layers/layer-picker';

const LayersNav = {
    name: 'CoreHeader',
    props: ['project'],
    data: function() {
        return {
        };
    },
    computed: {
        ...mapGetters([
            'layers',
            'layerByID',
            'currentLayer',
            'validLayers',
            'collaboratorByUID',
            'user',
            'ownerUID'
        ]),
        collaborator: function() {
            return this.collaboratorByUID(this.user['.key']);
        },
        userRef: function() {
            return firebase.database().ref(`users/${this.user['.key']}`);
        },
        canEdit: function() {
            return (this.collaborator || this.ownerUID === this.user.uid) && this.user.active_pay;
        }
    },
    methods: {
        open() {
            // console.log('opening layers nav');
        },
        closeLayersNav() {
            this.$refs.layerNav.close();
        },
        back() {
            this.closeLayersNav();
            NavBus.$emit('main-nav.open');
        },
        addLayer(layer) {
            this.$store.dispatch('addLayer', layer);
            this.showLayer(layer);
            this.$store.dispatch('showNotes', layer);

            // UPDATE COLLABORATOR
            if (this.collaborator) {
                const tempCollab = this.collaborator;
                tempCollab.layers[layer.id] = true;
                this.$store.dispatch('updateCollaborator', tempCollab);
            }
        },
        hideLayer(layer) {
            this.$store.dispatch('hideLayer', layer);
        },
        showLayer(layer) {
            this.$store.dispatch('showLayer', layer);
        }
    },
    created: function() {
        NavBus.$on('layers-nav.open', () => {
            if (this.$refs.layerNav) {
                this.$refs.layerNav.open();
            }
        });
    },
    components: {
        'layer-list': LayersLayerList,
        'layer-new': LayersLayerNew,
        'layer-picker': LayersLayerPicker
    }
};
export default LayersNav;

</script>

<style></style>


// WEBPACK FOOTER //
// nav.vue?53a63972